import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as RetailerService from '_services/retailer-service';

//#region action

// fetch retailer of selected airport from firebase
export const getAirportRetailers = createAsyncThunk('retailers/getAirportRetailers', async (iata) => {
    return RetailerService.getRetailersByIata(iata);
})

// fetch retailer of selected airport from firebase
export const getRetailer = createAsyncThunk('retailers/getRetailer', async (id) => {
    return RetailerService.getRetailerById(id);
})

// not used in user-marketplace
/* update retailer info*/
export const updateRetailer = createAsyncThunk('retailer/updateRetailer', async (retailer) => {
    return RetailerService.updateRetailer(retailer);
})

/* create new retailer */
export const createRetailer = createAsyncThunk('retailer/postRetailer', async (retailer) => {
    return RetailerService.postRetailer(retailer);
})

/* delete retailer */
export const deleteRetailer = createAsyncThunk('retailer/deleteRetailer', async (id) => {
    return RetailerService.deleteRetailer(id);
})
//#endregion

//#region slice setup
//initial state
const initialState = {

    //data
    selectedRetailer: null,
    retailers: [],

    //status
    gettingRetailersStatus: "idle",
    addingRetailerStatus: "idle",
    updatingRetailerStatus: "idle",
    deleteRetailerStatus: "idle",
    getOneRetailerStatus: "idle",

    //errors
    gettingRetailersError: null,
    addingRetailerError: null,
    updatingRetailerError: null,
    deleteRetailerError: null,
    getOneRetaileError: null,
}
// slice configue
const retailerSlice = createSlice({
    name: 'retailer',
    initialState,
    reducers: {
        reset: (state) => initialState,
        resetAddingRetailerStatus: (state) => {
            return {
                ...state,
                addingRetailerStatus: "idle",
                addingRetailerError: null
            }
        },
        resetUpdatingRetailerStatus: (state) => {
            return {
                ...state,
                updatingRetailerStatus: "idle",
                updatingRetailerError: null
            }
        },
        resetSelectedRetailer: (state) => {
            return {
                ...state,
                selectedRetailer: null
            }
        },
        setSelectedRetailer: (state, action) => {
            return {
                ...state,
                selectedRetailer: action.payload
            }
        },
        resetRetailerStatus: (state, action) => {
            return {
                ...state,
                gettingRetailersStatus: "idle",
                gettingRetailersError: null
            }
        }
    },
    extraReducers: {
        [getAirportRetailers.pending]: (state) => {
            return {
                ...state,
                gettingRetailersStatus: 'loading',
            }
        },
        [getAirportRetailers.fulfilled]: (state, action) => {
            return {
                ...state,
                gettingRetailersStatus: 'succeeded',
                retailers: action.payload,
            }
        },
        [getAirportRetailers.rejected]: (state, action) => {
            return {
                ...state,
                gettingRetailersStatus: 'failed',
                gettingRetailersError: action.error.message,
            }
        },
        [updateRetailer.pending]: (state) => {
            return {
                ...state,
                updatingRetailerStatus: 'loading',
            }
        },
        [updateRetailer.fulfilled]: (state, action) => {
            return {
                ...state,
                updatingRetailerStatus: 'succeeded',
            }
        },
        [updateRetailer.rejected]: (state, action) => {
            return {
                ...state,
                updatingRetailerStatus: 'failed',
                updatingRetailerError: action.error.message,
            }
        },
        [createRetailer.pending]: (state, action) => {
            return {
                ...state,
                addingRetailerStatus: 'loading',
            }
        },
        [createRetailer.fulfilled]: (state, action) => {
            return {
                ...state,
                selectedRetailer: action.payload,
                addingRetailerStatus: 'succeeded',
            }
        },
        [createRetailer.rejected]: (state, action) => {
            return {
                ...state,
                addingRetailerStatus: 'failed',
                addingRetailerError: action.error.message,
            }
        },
        [deleteRetailer.pending]: (state, action) => {
            return {
                ...state,
                deleteRetailerStatus: 'loading',
            }
        },
        [deleteRetailer.fulfilled]: (state, action) => {
            return {
                ...state,
                deleteRetailerStatus: 'succeeded',
            }
        },
        [deleteRetailer.rejected]: (state, action) => {
            return {
                ...state,
                deleteRetailerStatus: 'failed',
                deleteRetailerError: action.error.message,
            }
        },
        [getRetailer.pending]: (state, action) => {
            return {
                ...state,
                getOneRetailerStatus: 'loading',
            }
        },
        [getRetailer.fulfilled]: (state, action) => {

            return {
                ...state,
                getOneRetailerStatus: "succeeded",
                selectedRetailer: action.payload || null,
            }
        },
        [getRetailer.rejected]: (state, action) => {
            return {
                ...state,
                getOneRetailerStatus: 'failed',
                getOneRetaileError: action.error.message,
            }
        },
    }
});

//#endregion

//#region selectors
export const { reset, setSelectedRetailer, resetAddingRetailerStatus, resetSelectedRetailer, resetUpdatingRetailerStatus, resetRetailerStatus } = retailerSlice.actions;
export const selectRetailers = state => state.retailer.retailers;
export const selectOneRetailer = state => state.retailer.selectedRetailer;
export const selectGettingRetailerStatus = state => state.retailer.getOneRetailerStatus;
export const selectAddingRetailerError = state => state.retailer.addingRetailerError;
export const selectAddingRetailerStatus = state => state.retailer.addingRetailerStatus;
export const selectAirportRetailerStatus = state => state.retailer.gettingRetailersStatus;
export const selectOneRetailerError = state => state.retailer.getOneRetaileError;


//#endregion

//#region process state
export const getRetailersTitles = (state) => {
    if (!state.retailer.retailers) return []

    return state.retailer.retailers.map(retailer => {
        return {
            title: retailer.retailerName,
            id: retailer._id,

        }
    })
}
//#endregion

export default retailerSlice.reducer;
